import { Component, OnInit } from '@angular/core';
import { HubConnectionBuilder, LogLevel, HubConnection } from '@microsoft/signalr';

@Component({
    selector: 'pcg-push-notification',
    templateUrl: './push-notification.component.html',
    styleUrls: ['./push-notification.component.scss'],
    standalone: false
})
export class PushNotificationComponent implements OnInit {
	private hubConnection: HubConnection | undefined;
	showNotification = false;

	constructor() {}

	/** Reload the page */
	hardReload() {
		window.location.reload();
		return false;
	}

	ngOnInit() {
		// WebSockets
		this.hubConnection = new HubConnectionBuilder()
			.configureLogging(LogLevel.Critical)
			.withUrl('/install-notify')
			.build();
		this.hubConnection.start().catch(err => console.error(err.toString()));

		this.hubConnection.on('install', () => {
			this.showNotification = true;
		});

		const setTimerEvent = () => {
			let hasUser: boolean = localStorage.getItem('user') != null;
			if (this.showNotification === false && hasUser == true) {
				// Time to wait before attempting reconnect.
				// Randomized to prevent denial of servicing ourselves.
				const timeToWait = (Math.trunc(Math.random() * 10000) % 6) + 1;

				// Continuously try to reconnect
				// to server on failure
				setTimeout(() => {
					this.hubConnection.start().catch(setTimerEvent);
				}, timeToWait);
			}
		};

		this.hubConnection.onclose(setTimerEvent);
	}
}
